module.exports = __webpack_public_path__ + "img/invoice_apply_room.3c0aa915.svg";